import React, { Fragment, Component } from 'react';
import { Link } from 'react-router-dom';

import Cards from '../Cards';
import makeUrl from '../../../lib/makeUrl';
import LoadMore from './LoadMore';
import AddEntity from './AddEntity';

// import { entityComponents } from '../../../constants/entityComponents';
import { orderedArray, arrayForModal } from '../utils';
import '../ServiceModal/ServiceModal.css';

// const dayCardTypes = ['lodgings', 'flights', 'themes', 'places', 'sidetrips'];

type Props = {
  patchInfo: {},
  openSlider: Function,
  setServiceModalConfig: Function,
  route: {
    segment_type: string,
    segment_id: string,
    name: string,
    posters: Array,
  },
};

export default class DayTrailDesktop extends Component<Props> {
  render() {
    const { patchInfo, editingPatchInfoId } = this.props;
    const isDraft = patchInfo.segmentId === editingPatchInfoId;
    return (
      <li>
        <div className="timeline-event">
          <div>
            {this.renderStats()}
            <div className="timeline-detail">
              <div className="row">
                <LoadMore
                  lastComponent={
                    <div className="col-lg-3 col-md-5 col-12">
                      <AddEntity
                        patchInfo={patchInfo}
                        modalType={'trekDayModal'}
                        text="Add your own cards"
                      />
                    </div>
                  }
                  isDraft={isDraft}
                  elmId={`a${patchInfo.segmentId}`}
                >
                  {this.renderEntities()}
                </LoadMore>
              </div>
              <hr />
            </div>
          </div>
        </div>
      </li>
    );
  }

  renderStats = () => {
    const {
      route,
      patchInfo: { placeId, placeName },
      region,
    } = this.props;
    if (route.segment_type === 'path') {
      return (
        <Fragment>
          <label className="timeline-label label-time" />
          <div className="label-time-text">
            <li>{placeName.toUpperCase()}</li>
            <li>
              {' '}
              {/* {route.stats.avg_flight_hrs || route.stats.avg_walking_hrs} hrs{" "} */}
            </li>
          </div>
        </Fragment>
      );
    } else if (route.segment_type === 'point') {
      return (
        <label className="timeline-label">
          <Link to={makeUrl.placeDetails(placeName, placeId, region)}>
            {placeName.toUpperCase()}
          </Link>
        </label>
      );
    } else return null;
  };

  renderEntities = () => {
    const { route, openSlider, patchInfo, setServiceModalConfig, date } = this.props;
    let sortedArray = [];
    let filteredArray = [];

    sortedArray = route.posters && orderedArray(route.posters);
    // const sightingsArray = sortedArray.filter(card => card.poster_type === "sightings");
    // const attractionsArray = sortedArray.filter(card => card.poster_type === "attractions");
    // const sidetripsArray = sortedArray.filter(card => card.poster_type === "sidetrips");
    filteredArray = arrayForModal(sortedArray);

    return sortedArray.map((entity, i) => {
      let slideIndex = '';
      // if (entity.poster_type === "sightings") {
      //   slideIndex = sightingsArray.indexOf(entity);
      // } else if (entity.poster_type === "attractions") {
      //   slideIndex = attractionsArray.indexOf(entity);
      // } else if (entity.poster_type === "sidetrips") {
      //   slideIndex = sidetripsArray.indexOf(entity);
      // }
      slideIndex = filteredArray.indexOf(entity);

      return (
        <div className="col-lg-3 col-md-5 col-3" key={`${entity.id}+${i}`}>
          <Cards
            cardData={entity}
            theme={entity.poster_type}
            slideIndex={slideIndex}
            openSlider={openSlider}
            setServiceModalConfig={setServiceModalConfig}
            patchInfo={patchInfo}
            placeName={patchInfo.placeName}
            modalType="dayModal"
            dayDate={date}
          />
        </div>
      );
    });
  };
}



// WEBPACK FOOTER //
// ./src/screens/Trek/DayTrail/DayTrailDesktop.js